import { Button } from '@givebutter/primitives/button';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    CreateCampaignDialogForm,
    useCreateCampaignDialogContext,
} from 'components/create-campaign-dialog/CreateCampaignDialogContext';
import * as Form from 'components/form';

const CampaignTitleInput = () => {
    const { setStep } = useCreateCampaignDialogContext();
    const {
        control,
        path,
        watch,
        formState: { errors },
    } = Form.useFormContext<CreateCampaignDialogForm>();

    const [type] = watch(['type']);

    return (
        <div className="flex h-full w-full items-center justify-center px-4 sm:px-0">
            <div className="mx-auto flex w-full flex-col gap-4 sm:w-[25.5rem]">
                <h3 className="text-xl font-medium">Campaign title</h3>
                <div className="flex flex-col gap-[0.375rem]">
                    <Form.Container>
                        <Form.TextInputRoot
                            control={control}
                            name="campaignName"
                            rules={{
                                validate: value =>
                                    value.trim().length > 0 ? true : 'Please enter a title.',
                            }}
                        >
                            <Form.TextInputForm placeholder={'Enter campaign title'} />
                        </Form.TextInputRoot>
                        <Form.Error name={path('campaignName')} />
                    </Form.Container>
                    <p className="text-sm text-gray-600">Don't worry, you can change this later.</p>
                </div>
                <div className="flex flex-col-reverse justify-between gap-2 sm:flex-row sm:gap-0">
                    <Button
                        variant="transparent"
                        color="neutral"
                        className="font-medium text-gray-600"
                        onClick={() => setStep(type === 'collect' ? 'start' : 'addFeatures')}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} className="hidden sm:inline-block" />
                        Back
                    </Button>
                    <Form.SubmitButton disabled={Object.keys(errors).length > 0}>
                        Let's go!
                    </Form.SubmitButton>
                </div>
            </div>
        </div>
    );
};

export { CampaignTitleInput };
